var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ConfirmationDialog2", { ref: "confirmationDialog" }),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          attrs: { disabled: _vm.disabled },
          on: {
            click: function ($event) {
              return _vm.newQueryHandler()
            },
          },
        },
        [
          _c("v-icon", { staticClass: "mr-2", attrs: { color: "info" } }, [
            _vm._v("add"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-capitalize" }, [
            _vm._v(_vm._s(_vm.$t("Button.New"))),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }